<template>
	<div>
		<a-page-header style="background: #fff;" title="订单管理" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'订单管理'}]}}">
			<a-form-model layout="inline" :form="searchForm" @submit="searchSubmit">
				<a-form-model-item>
					<a-input-group compact>
						<a-select style="width: 120px" v-model="searchForm.type">
							<a-select-option :value="1">订单号</a-select-option>
							<a-select-option :value="2">支付单号</a-select-option>
							<a-select-option :value="3">姓名</a-select-option>
							<a-select-option :value="4">电话</a-select-option>
							<a-select-option :value="5">昵称</a-select-option>
							<a-select-option :value="6">商品名称</a-select-option>
						</a-select>
						<a-input style="width: 300px" placeholder="请输入内容" v-model="searchForm.word" />
					</a-input-group>
				</a-form-model-item>
				<!-- <a-form-model-item>
					<a-select allowClear style="width: 150px" v-model="searchForm.orderPayType" placeholder="支付类型">
						<a-select-option :value="1">
							微信支付
						</a-select-option>
						<a-select-option :value="2">
							钱包支付
						</a-select-option>
					</a-select>
				</a-form-model-item> -->
				<!-- <a-form-model-item>
					<a-select allowClear style="width: 150px" v-model="searchForm.storeId" placeholder="所属门店" :options="storeList"></a-select>
				</a-form-model-item> -->
				<a-form-model-item>
					<a-range-picker :locale="locale" format="YYYY-MM-DD" @change="dateChange" />
				</a-form-model-item>
				<a-form-model-item>
					<a-button type="primary" html-type="submit">
						搜索
					</a-button>
				</a-form-model-item>
			</a-form-model>
			<template slot="footer">
				<a-tabs @change="tabChange" v-model="status">
					<a-tab-pane key="0" tab="全部订单">
					</a-tab-pane>
					<!-- <a-tab-pane key="2">
						<span slot="tab">
							预约订单 <span style="color:#ff4d4f ;font-weight: 700;" v-if="orderNum.yyz">{{orderNum.yyz}}</span>
						</span>
					</a-tab-pane>
					<a-tab-pane key="3">
						<span slot="tab">
							待核销订单 <span style="color:#ff4d4f ;font-weight: 700;" v-if="orderNum.dhx">{{orderNum.dhx}}</span>
						</span>
					</a-tab-pane> -->
					<a-tab-pane key="2" tab="已付款订单">
					</a-tab-pane>
				</a-tabs>
			</template>
		</a-page-header>

		<!-- 列表 -->
		<div class="mainBox">
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id" :pagination="pagination" :loading="loading" @change="handleTableChange">
					<span slot="orderNum" slot-scope="text,orderNum">
						<div>
							<a-icon type="file-text" /> {{orderNum.orderNum}}</div>
						<div v-if="orderNum.orderPayType == 1">
							<a-icon type="wechat" /> {{orderNum.orderWxpayNum}}</div>
					</span>
					<span slot="userInfo" slot-scope="text,userInfo">
						<!-- <a-tag color="orange" v-if="userInfo.userInfo.memberSfName">{{userInfo.userInfo.memberSfName}}</a-tag> -->
						<div>
							<a-icon type="user" /> {{userInfo.name}}
						</div>
						<div>
							<a-icon type="mobile" /> {{userInfo.phone}}
						</div>
						<!-- <div style="margin-top: 10px;">
							<a-avatar :src="userInfo.wxInfo.headpic" size="small" />
							{{userInfo.wxInfo.nickname}}
						</div> -->
					</span>
					<span slot="goodsInfo" slot-scope="text,goodsInfo">
						<div v-for="(item,index) in goodsInfo.goodsInfo" :style="index + 1 != goodsInfo.goodsInfo.length ? 'border-bottom: 1px #bfbfbf dashed' : ''"
						 style="display: flex;justify-content: space-between;padding: 10px; ">
							<div style="padding-right: 10px;">
								<a-avatar shape="square" :size="50" :src="item.goodsThumb" />
							</div>
							<div style="width: 80%;display: flex;align-content: space-between;flex-direction:column">
								<div style="font-weight: 700;margin-bottom: 5px;">
									{{item.goodsName}}
									<a-tag color="orange" v-if="item.isSaleGoods == 1">特价商品</a-tag>
								</div>
								<div style="display: flex;justify-content: space-between;">
									<div>
										<a-tag color="blue" v-if='item.goodsSpecsName'>{{item.goodsSpecsName}}</a-tag> {{item.goodsPrice}} 元
										<span style="color:#bfbfbf ;margin-left: 10px;font-size: 12px;">{{item.Integral}} 积分</span>
									</div>
									<div>
										× {{item.orderPayNum}} {{item.goodsUnit}}
									</div>
								</div>
							</div>
						</div>
					</span>
					<span slot="stores" slot-scope="text,stores">
						<a @click="toStoreDetail(stores.storesInfo.storesId)">{{stores.storesInfo.storesName}}</a>
					</span>
					<span slot="orderPay" slot-scope="text,orderPay">
						<div>
							<a-tag color="green" v-if="orderPay.orderPayType == 1">
								<a-icon type="wechat" /> 微信支付</a-tag>
							<a-tag color="blue" v-if="orderPay.orderPayType == 2">
								<a-icon type="wallet" /> 钱包支付</a-tag>
						</div>
						<div style="font-size: 24px;font-weight: 700;">{{orderPay.orderPayAll}} 元</div>
						<div style="font-size: 14px;color:#bfbfbf ;">{{orderPay.orderIntegralAll}} 积分</div>
					</span>
					<span slot="orderStatus" slot-scope="text,orderStatus">
						<template v-if="orderStatus.orderStatus == 2">
							<a-tag color="orange">
								<a-icon type="history" /> 预约</a-tag>
							<div>
								<a-icon type="calendar" /> {{orderStatus.appointmentDate}}</div>
						</template>

						<a-tag color="blue" v-if="orderStatus.orderStatus == 3">
							<a-icon type="qrcode" /> 待核销</a-tag>
						<a-tag color="green" v-if="orderStatus.orderStatus == 2">
							<a-icon type="check-circle" /> 已完成</a-tag>
					</span>
					<span slot="action" slot-scope="text, record">
						<a @click="toDetail(record.id)">详情</a>
						<a-divider type="vertical" />
						<a-popconfirm title="请确认是否删除？" okText="是" cancelText="否" @confirm="del(record.id)">
							<a href="javascript:;" style="color: #ff4d4f;">删除</a>
						</a-popconfirm>
					</span>
				</a-table>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from "moment"
	import 'moment/locale/zh-cn'
	import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
	var storage = window.localStorage
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '订单号',
			dataIndex: 'orderNum',
			scopedSlots: {
				customRender: 'orderNum'
			},
		},
		{
			title: '下单人',
			dataIndex: 'userInfo',
			scopedSlots: {
				customRender: 'userInfo'
			},
      width: '120px'
		},
    {
    	title: '收货地址',
      dataIndex: 'address',
      width: '200px'
    },
		// {
		// 	title: '所属门店',
		// 	dataIndex: 'stores',
		// 	scopedSlots: {
		// 		customRender: 'stores'
		// 	},
		// },
		{
			title: '商品信息',
			dataIndex: 'goodsInfo',
			width: '400px',
			scopedSlots: {
				customRender: 'goodsInfo'
			},
		},
		{
			title: '支付信息',
			dataIndex: 'orderPay',
			scopedSlots: {
				customRender: 'orderPay'
			},
		},
		{
			title: '下单时间',
			dataIndex: 'payTime',
		},
		// {
		// 	title: '订单状态',
		// 	dataIndex: 'orderStatus',
		// 	scopedSlots: {
		// 		customRender: 'orderStatus'
		// 	},
		// },
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	export default {
		data() {
			return {
				moment,
				locale,
				columns,
				list: [],
				storeList: [],
				searchForm: {
					type: 1,
				},
				pagination: {
					pageSize: 20,
					total: 0,
					current: 1
				},
				loading: false,
				status: '0',
				orderNum: '',
				uid:''
			};
		},

		mounted() {
			if (this.$route.query.status) {
				this.status = this.$route.query.status
			}
			this.uid = this.$route.query.memberId
			if(this.$route.query.storeId){
				this.searchForm.storeId = parseInt(this.$route.query.storeId) 
			}
			this.getList()
			this.getCount()
			this.getStoreList()
		},

		watch: {
			$route() {
				if (this.$route.query.status) {
					this.status = this.$route.query.status
				}
				this.getList()
				this.getCount()
			}
		},

		methods: {
      
			dateChange(value, dateString){
				console.log(value, dateString)
				this.searchForm.addTimeBegin = dateString[0]
				this.searchForm.addTimeEnd = dateString[1]
			},
			
			tabChange() {
				this.getList()
				this.getCount()
			},

			toStoreDetail(id) {
				this.$router.push('/door/doorDetail?id=' + id)
			},

			toDetail(id) {
				this.$router.push('/order/orderDetail?id=' + id)
			},

			searchSubmit(e) {
				e.preventDefault()
				this.getList()
			},

			handleTableChange(pagination, filters, sorter) {
				this.list = []
				this.pagination.current = pagination.current
				this.pagination.field = sorter.field
				this.pagination.order = sorter.order
				this.getList()
			},
      
      del(id) {
      	this.$http.post('/admin/index.php/admin/shop/ordersDel', {
      		id: id
      	}).then((res) => {
      		if (res.data.code == 1) {
      			this.$message.success(res.data.msg);
      			this.getList();
      		} else {
      			this.$message.error(res.data.msg);
      		}
      	})
      },

			getList() {
				this.loading = true
				var data = {
					uid:this.uid ? this.uid:'',
					status: this.status,
					page: this.pagination.current,
					num: this.pagination.pageSize,
					field: this.pagination.field,
					order: this.pagination.order,
					type: this.searchForm.type,
					word: this.searchForm.word,
					orderPayType: this.searchForm.orderPayType,
					storeId: this.searchForm.storeId,
					addTimeBegin: this.searchForm.addTimeBegin,
					addTimeEnd: this.searchForm.addTimeEnd,
				}
				this.$http.post('/admin/index.php/admin/Shop/ordersList', data).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.list = res.data.data
						this.pagination.total = res.data.count
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			getStoreList() {
				this.$http.get('/admin/index.php/admin/Shop/storePullList').then(res => {
					if (res.data.code == 1) {
						this.storeList = res.data.data
					}
				})
			},

			getCount() {
				this.$http.get('/admin/index.php/admin/Shop/orderStatusCount').then((res) => {
					if (res.data.code == 1) {
						this.orderNum = res.data.data
					}
				}).catch(err => {
					console.log(err)
				})
			},
		}
	}
</script>

<style scoped="">
	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}
</style>
